import { orchestrator } from 'satcheljs';
import sendReadReceipt from '../services/sendReadReceipt';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import addInfoBarMessage from 'owa-info-bar/lib/actions/addInfoBarMessage';
import initializeSendingReadReceipt from '../actions/initializeSendingReadReceipt';
import removeSuppressReceiptFromItem from '../actions/removeSuppressReceiptFromItem';
import { trace } from 'owa-trace';

/**
 * Initialize read receipt sending to the user
 */
export default orchestrator(initializeSendingReadReceipt, async actionMessage => {
    const { message, key, itemViewState } = actionMessage;
    try {
        removeInfoBarMessage(itemViewState, key);
        // Make service call
        const response: boolean = await sendReadReceipt(message.ItemId);

        if (response) {
            // Add infobar for sent receipt
            addInfoBarMessage(itemViewState, 'infoReadReceiptSent');
            // Remove the action type from message, so that when user clicks on the conversation again,
            // receipt is no longer shown. This is required fro conversation view, as message view dispatches the getItem call
            // automatically on every click
            removeSuppressReceiptFromItem(message);
        }
    } catch (e) {
        trace.error('Error while initializing send read receipts ' + e);
    }
});
